module.exports = __webpack_public_path__ + "media/images/sp/accessories/men/men_02_thumb-1e9ea76fe0a5e4cffba79c86f6644d2d.jpg";